import { HalResource } from '../hal/models/HalResource';
import { Page } from './Page';
/**
 * Class representing an Assigned Content Type for an Algolia Search Index.
 */
export class AssignedContentType extends HalResource {
    constructor() {
        super(...arguments);
        this.related = {
            unassign: (id) => this.deleteLinkedResource('unassign', {
                id,
            }),
            recreateWebhook: () => this.performActionWithoutResourceResponse('recreate-webhook'),
        };
    }
}
/**
 * @hidden
 */
export class AssignedContentTypePage extends Page {
    constructor(data) {
        super('assigned-content-types', AssignedContentType, data);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNzaWduZWRDb250ZW50VHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWwvQXNzaWduZWRDb250ZW50VHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sMkJBQTJCLENBQUM7QUFDeEQsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFFBQVEsQ0FBQztBQUU5Qjs7R0FFRztBQUNILE1BQU0sT0FBTyxtQkFBb0IsU0FBUSxXQUFXO0lBQXBEOztRQXFCa0IsWUFBTyxHQUFHO1lBQ3hCLFFBQVEsRUFBRSxDQUFDLEVBQVUsRUFBaUIsRUFBRSxDQUN0QyxJQUFJLENBQUMsb0JBQW9CLENBQUMsVUFBVSxFQUFFO2dCQUNwQyxFQUFFO2FBQ0gsQ0FBQztZQUVKLGVBQWUsRUFBRSxHQUFrQixFQUFFLENBQ25DLElBQUksQ0FBQyxvQ0FBb0MsQ0FBQyxrQkFBa0IsQ0FBQztTQUNoRSxDQUFDO0lBQ0osQ0FBQztDQUFBO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLE9BQU8sdUJBQXdCLFNBQVEsSUFBeUI7SUFDcEUsWUFBWSxJQUFVO1FBQ3BCLEtBQUssQ0FBQyx3QkFBd0IsRUFBRSxtQkFBbUIsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUM3RCxDQUFDO0NBQ0YifQ==